import { Focusable, ProgressBar, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

import type { HealthCheckOverallStatus } from './types';

import styles from './HealthCheck.module.css';

const textMap: Record<HealthCheckOverallStatus, string> = {
  waiting: 'Health check waiting',
  loading: 'Health check waiting',
  pass: 'Healthy',
  fail: 'Health errors',
  warning: 'Health warnings',
  error: 'Health check failed to load',
  'partial-error': 'Health check failed to load partially',
};

const iconMap: Record<HealthCheckOverallStatus, IconProps['name'] | undefined> = {
  loading: 'progress',
  pass: 'check-circle',
  warning: 'warning',
  fail: 'cancel-circle',
  error: 'alert-rhombus',
  'partial-error': 'alert-rhombus',
  waiting: 'minus',
};

export function HealthCheckIcon({
  status,
  showTooltip = false,
}: {
  status: HealthCheckOverallStatus;
  showTooltip?: boolean;
}) {
  const content =
    status === 'loading' ? (
      <ProgressBar isIndeterminate size="small" aria-label={textMap[status]} />
    ) : (
      <Icon name={iconMap[status]} size="small" className={styles.buttonIcon} data-status={status} />
    );

  if (showTooltip) {
    return (
      <TooltipTrigger delay={0}>
        <Focusable aria-label={textMap[status]}>{content}</Focusable>
        <Tooltip>{textMap[status]}</Tooltip>
      </TooltipTrigger>
    );
  }

  return content;
}
